import { ChangeEvent, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimesCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

interface Props {
  item: any;
  onClose: () => void;
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | ChangeEvent<HTMLSelectElement>) => void;
  handleSubmit: () => void;
}

const FormCardWrap = styled.div`
  width: 100%;
  margin: auto;
  border-radius: 0.3rem;

  .inline-flex {
    display: flex;
    position: relative;
    margin: 0 1.25rem;
    width: calc(100% - 40px);
    height: 100%;
    text-align: left;
    border: 1px solid #cccccc;
    border-radius: 0.35rem;

    &.detail {
      margin-top: 1.75rem;
    }
    &.tab {
      border-top-left-radius: 0;
    }
    .w-100 {
      flex: 1;
      padding: 1.25rem 0;
      width: 100%;

      .card-text {
        display: flex;
        width: calc(100% - 1.25rem);
        padding: 0 0.625rem;
        align-items: center;

        p {
          margin: 0;
          padding: 1rem 0.875rem;
          width: 30%;
          min-height: 29px;
          font-size: 0.875rem;
          color: #555555;
          line-height: 1.8rem;
          border-bottom: 1px solid #e3e8f0;
          background: #e3e8f0;
          box-sizing: inherit;

          span {
            font-size: 12px;
          }
          .required {
            margin-left: 3px;
            font-size: 0.875rem !important;
            color: #ef4b56;
          }
        }
      }
      .card-text-input {
        margin: 0.625rem 0 0.625rem 1.25rem;
        padding: 0 0.5rem;
        width: 70%;
        height: 2.5rem;
        font-size: 0.875rem;
        color: #333333;
        line-height: 1.2;
        border: 1px solid #777777;
        border-radius: 0.18775rem;
        box-sizing: inherit;

        :disabled {
          color: #777777;
          border: 1px solid #cccccc;
          background: #eeeeee;
        }
        &:focus-visible {
          outline: 1.5px solid #044dac;
        }
      }
      .card-textarea {
        margin: 0.625rem 0 0.625rem 1.25rem;
        padding: 0 0.5rem;
        width: 70%;
        font-size: 0.875rem;
        color: #333333;
        line-height: 1.2;
        border: 1px solid #777777;
        border-radius: 0.18775rem;
        box-sizing: inherit;
      }
      .card-text-select {
        margin: 0.625rem auto 0.625rem 1.25rem;
        padding: 0 0.5rem;
        width: 70%;
        height: 2.5rem;
        font-size: 0.875rem;
        color: #333333;
        border: 1px solid #777777;
        border-radius: 0.18775rem;
        box-sizing: inherit;

        :disabled {
          color: #777777;
          border: 1px solid #cccccc;
          background: #eeeeee;
        }
        &:focus-visible {
          outline: 1.5px solid #044dac;
        }
      }
    }
  }
  .card-foot {
    display: inline-flex;
    margin: 0 1.25rem;
    padding: 1.25rem 0;
    width: calc(100% - 40px);
    height: 2rem;
    justify-content: space-between;

    .btn-item-cancel {
      padding: 0.5rem;
      height: 2.3rem;
      min-width: 5rem;
      font-size: 0.875rem;
      font-weight: bold;
      color: #ffffff;
      border: 0px;
      border-radius: 0.35rem;
      background-color: #dc343f;
      cursor: pointer;
      box-shadow:
        0 0 1px 0 rgb(0 0 0 / 20%),
        0 2px 4px -2px rgb(0 0 0 / 30%);

      :hover {
        background: #ef4b56;
      }
    }
    .btn-item-add {
      padding: 0.5rem;
      height: 2.3rem;
      min-width: 5rem;
      font-size: 0.875rem;
      font-weight: bold;
      color: #ffffff;
      border: 0px;
      border-radius: 0.35rem;
      background-color: #044dac;
      cursor: pointer;
      box-shadow:
        0 0 1px 0 rgb(0 0 0 / 20%),
        0 2px 4px -2px rgb(0 0 0 / 30%);

      :hover {
        background: #4c9ffe;
      }
    }
  }
  .card-box {
    margin-top: 0.625rem;
    display: flex;
    width: 100%;
    padding: 0 0.625rem;
    align-items: stretch;
    flex-direction: column;
    box-sizing: border-box;

    p {
      margin: 0;
      padding: 0.875rem;
      width: 100%;
      font-size: 0.875rem;
      color: #555555;
      line-height: 1.8rem;
      border-bottom: 1px solid #e3e8f0;
      background: #e3e8f0;
      box-sizing: inherit;

      span {
        font-size: 12px;
      }
      .required {
        margin-left: 3px;
        font-size: 0.875rem !important;
        color: #ef4b56;
      }
    }
  }
  .card-box-textarea-container {
    width: 100%;
    font-size: 0.875rem;
    color: #333333;
    line-height: 1.2;

    .card-box-textarea {
      padding: 0.5rem;
      width: 100%;
      height: 15rem;
      border: 1px solid #777777;
      border-radius: 0.18775rem;
      resize: none;
      box-sizing: border-box;

      :disabled {
        color: #777777;
        border: 1px solid #cccccc;
        background: #eeeeee;
      }
      &:focus-visible {
        outline: 1.5px solid #044dac;
      }
    }
  }
`;
const FormCardTitle = styled.div`
  display: inline-flex;
  position: relative;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
  width: 100%;
  text-align: left;
  color: #ffffff;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  background: #044dac;
  box-sizing: border-box;

  .detail {
    position: relative;
    padding: 0.675rem 0;
    margin: 0 1.25rem;
    height: 36px;
    width: calc(100% - 40px);

    .filter {
      position: absolute;
      bottom: 10px;
      right: 0;
    }
  }
  h1 {
    margin: 0;
    font-size: 18px;

    span {
      margin: 0 5px;
      font-size: 0.875rem;
      color: #e6e5e8;
    }
  }
  svg {
    position: absolute;
    top: 1rem;
    right: 1.25rem;
    font-size: 1.625rem;
    cursor: pointer;
  }
`;

const AnnouncementCreate = ({ item, onClose, handleChange, handleSubmit }: Props) => {
  return (
    <Fragment>
      <FormCardWrap>
        <FormCardTitle>
          <h1>공지사항 등록</h1>
          <FontAwesomeIcon icon={faXmark} onClick={onClose} />
        </FormCardTitle>
        <div className="inline-flex">
          <div className="w-100">
            <div className="card-box">
              <p>
                <b>제목</b>
                <span className="required">*</span>
              </p>
              <input style={{ height: "48px" }} value={item.title} name="title" onChange={handleChange} />
            </div>

            <div className="card-box">
              <p>
                <b>상세 내용</b>
                <span className="required">*</span>
              </p>
              <div className="card-box-textarea-container">
                <textarea className="card-box-textarea" value={item.content} name="content" onChange={handleChange} />
              </div>
            </div>
            <div className="card-box">
            <p>
            <b>노출 순서</b>
              <span className="required">*</span>
            </p>
            <div className="card-box-textarea-container">
              <select
                className="card-text-select"
                value={item.sort_order}
                name="sort_order"
                onChange={handleChange}
              >
                <option value={""}>-</option>
                <option value={"1"}>1</option>
                <option value={"2"}>2</option>
                <option value={"3"}>3</option>
              </select>
          </div>
        </div>
          </div>
        </div>
        <div className="card-foot">
          <div className="form-item-cancel">
            <button className="btn-item-cancel" id="staff-create-cancel-btn" onClick={onClose}>
              <FontAwesomeIcon icon={faTimesCircle} style={{ paddingRight: "3px" }} />
              <span>취소</span>
            </button>
          </div>
          <div className="form-item-add center">
            <button className="btn-item-add" id="staff-create-add-btn" onClick={handleSubmit}>
              <FontAwesomeIcon icon={faSave} style={{ paddingRight: "2px" }} />
              <span>저장</span>
            </button>
          </div>
        </div>
      </FormCardWrap>
    </Fragment>
  );
};

export default AnnouncementCreate;
